<template>
  <div class="teacher-invigilation-bg">
    <exam-header :canClickLogo="true"></exam-header>

    <div class="teacher-invigilation-container">
      <div class="teacher-invigilation-main">
        <!-- 页面标题 -->
        <div class="page-title-warp">
          <div class="back" @click="goBack"><i class="el-icon-arrow-left"></i>返回</div>
          <div class="title"><i></i>用户监考明细</div>
        </div>

        <!-- 用户信息卡片 -->
        <div class="user-info-card">
          <div class="info-left">
            <div class="info-item">
              <span class="label">用户名称：</span>
              <span class="value">{{ userInfo.name || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">用户手机号：</span>
              <span class="value">{{ userInfo.phone || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">用户id：</span>
              <span class="value">{{ userInfo.userId || '-' }}</span>
            </div>
            <div class="info-item">
              <span class="label">考试花费时间（分钟）：</span>
              <span class="value">{{ userInfo.examDurationMin }}</span>
            </div>
          </div>
          <div class="info-right">
            <div :class="userInfo.cheat ? 'warning' : 'success'" class="result-tag">
              监考结果：{{ userInfo.cheat ? '存疑' : '正常' }}
            </div>
          </div>
        </div>
        <div class="remarks-btn-wrap">
          <div class="button remark-btn" @click="showRemarkModal = true">填写备注</div>
        </div>

        <!-- 操作记录和备注区域 -->
        <div class="remarks-section" v-if="remarksList.length > 0">
          <div
            v-for="(remark, index) in remarksList"
            :key="index"
            class="remark-item"
          >
            <span class="remark-item_text">操作人：{{ remark.author.name }}</span>
            <span class="remark-item_text">备注时间：{{ remark.timeMs | formatTime }}</span>
            <span class="remark-item_text bold">{{ remark.content }}</span>
          </div>
        </div>

        <!-- 监考视频回放 -->
        <div class="playback-section" v-if="hasPlaybackData">
          <!-- 标签页切换 -->
          <div class="playback-tabs">
            <div
              class="tab-item"
              :class="{ active: selectedTab === 'pc' }"
              @click="switchTab('pc')"
            >
              主视角监考回放
            </div>
            <div
              class="tab-item"
              :class="{ active: selectedTab === 'mobile' }"
              @click="switchTab('mobile')"
            >
              第二视角监考回放
            </div>
          </div>

          <!-- 回放组件 -->
          <invigilate-playback
            v-if="currentSegments?.length"
            :startTimeSec="playbackRange.start"
            :endTimeSec="playbackRange.end"
            :segmentList="currentSegments"
            :cheats="filteredCheatMarkers"
          />
          <div v-else>
            <empty-page text="暂无数据"></empty-page>
          </div>
        </div>
      </div>
    </div>

    <!-- 填写备注弹窗 -->
    <base-modal
      v-if="showRemarkModal"
      class="remark-modal"
      :show-close="true"
      :hide-footer="true"
      headImgUrl=""
      title="用户监考明细-备注"
      @close="handleCloseRemarkModal"
    >
      <div slot="content" class="remark-modal-content">
        <el-form :model="remarkForm" :rules="remarkRules" ref="remarkForm" label-width="0">
          <el-form-item label="" prop="content">
            <el-input
              v-model="remarkForm.content"
              type="textarea"
              :rows="6"
              placeholder="请输入备注内容"
              maxlength="500"
              show-word-limit
            />
          </el-form-item>
        </el-form>
        <div class="modal-footer">
          <!-- <el-button @click="handleCloseRemarkModal">取消</el-button> -->
          <div class="button footer-btn" @click="handleSubmitRemark" :loading="submitting">
            确定
          </div>
        </div>
      </div>
    </base-modal>
  </div>
</template>

<script>
import { Form, FormItem, Input, Button, Tag, Message } from 'element-ui';
import ExamHeader from './components/teacherExamHeader.vue';
import BaseModal from '@/components/baseModal.vue';
import { getStudentInvigilateDetail, saveStudentInvigilateRemark } from '@/api/qzTeacher';
import dayjs from 'dayjs';
import InvigilatePlayback from './components/invigilatePlayback.vue';
import emptyPage from './components/emptyPage.vue';

export default {
  name: 'UserInvigilationDetail',
  components: {
    'exam-header': ExamHeader,
    'base-modal': BaseModal,
    'el-form': Form,
    'el-form-item': FormItem,
    'el-input': Input,
    'invigilate-playback': InvigilatePlayback,
    'empty-page': emptyPage,
  },
  filters: {
    formatTime(timeMs) {
      if (!timeMs) return '-';
      return dayjs(timeMs).format('YYYY.MM.DD HH:mm:ss');
    }
  },
  data() {
    return {
      roomId: this.$route.query.roomId,
      userId: this.$route.query.userId,
      userInfo: {
        name: '',
        phone: '',
        userId: '',
        examDurationMin: 0,
        cheat: false,
      },
      remarksList: [],
      showRemarkModal: false,
      submitting: false,
      remarkForm: {
        content: '',
      },
      remarkRules: {
        content: [
          { required: true, message: '请输入备注内容', trigger: 'change' },
          { min: 1, max: 500, message: '备注内容长度在 1 到 500 个字符', trigger: 'blur' }
        ]
      },
      selectedTab: 'pc', // 'pc' or 'mobile'
      // 回放数据
      playbackRange: { start: 0, end: 0 },
      segmentsMap: {
        pc: {
          segmentList: [],
          playbackRange: {
            start: 0,
            end: 0
          }
        },
        mobile: {
          segmentList: [],
          playbackRange: {
            start: 0,
            end: 0
          }
        },
      },
      cheatMarkers: [],
    };
  },
  computed: {
    segmentList() {
      return this.segmentsMap[this.selectedTab] || [];
    },
    filteredCheatMarkers() {
      return this.cheatMarkers.filter(item => item.device === this.selectedTab);
    },
    // 是否有回放数据
    hasPlaybackData() {
      return this.segmentsMap.pc.segmentList.length > 0 || this.segmentsMap.mobile.segmentList.length > 0;
    },
    // 当前选中的视频片段
    currentSegments() {
      return this.segmentsMap[this.selectedTab]?.segmentList || [];
    },
  },
  created() {
    this.getUserDetail();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },

    // 切换标签页
    switchTab(tab) {
      this.selectedTab = tab;
    },

    // 处理回放数据
    processPlaybackData(records) {
      // 处理PC端数据
      const pcList = Array.isArray(records.cameraPc) ? records.cameraPc : [];
      pcList.sort((a, b) => a.startTimeSec - b.startTimeSec);

      // 处理移动端数据
      const mobileList = Array.isArray(records.cameraMobile) ? records.cameraMobile : [];
      mobileList.sort((a, b) => a.startTimeSec - b.startTimeSec);

      // 更新segmentsMap
      this.segmentsMap.pc = {
        segmentList: pcList,
        playbackRange: {
          start: pcList[0]?.startTimeSec || Infinity,
          end: pcList[pcList.length - 1]?.endTimeSec || 0
        }
      };

      this.segmentsMap.mobile = {
        segmentList: mobileList,
        playbackRange: {
          start: mobileList[0]?.startTimeSec || Infinity,
          end: mobileList[mobileList.length - 1]?.endTimeSec || 0
        }
      };
      this.playbackRange = {
        start: Math.min(this.segmentsMap.pc.playbackRange.start, this.segmentsMap.mobile.playbackRange.start),
        end: Math.max(this.segmentsMap.pc.playbackRange.end, this.segmentsMap.mobile.playbackRange.end)
      }

      // 设置默认选中的标签页（优先显示有数据的）
      // if (pcList.length > 0) {
      //   this.selectedTab = 'pc';
      // } else if (mobileList.length > 0) {
      //   this.selectedTab = 'mobile';
      // }
    },

    // 获取用户监考详情
    getUserDetail() {
      if (!this.roomId || !this.userId) {
        Message.error('参数错误');
        return;
      }
      const startTime = parseInt(this.$route.query.startTime) || 0;
      getStudentInvigilateDetail({
        roomId: this.roomId,
        userId: this.userId,
        startTimeMs: startTime,
        endTimeMs: startTime + 1000 * 60 * 60 * 6, // 默认6小时
      }).then(res => {
        if (res.code === 200 && res?.body) {
          const { userInfo={}, remarks = [], records = {}, cheats = [] } = res.body;

          this.userInfo = {
            name: userInfo.name || '',
            phone: userInfo.phone || '',
            userId: this.userId,
            examDurationMin: Math.round(userInfo.costTimeSec / 60),
            cheat: cheats.length > 0,
          };

          this.remarksList = remarks.map(remark => ({
            author: remark.author || { name: '未知' },
            content: remark.content || '',
            timeMs: remark.timeMs || Date.now()
          }));

          // 组装回放数据
          this.processPlaybackData(records);

          const cheatsList = Array.isArray(cheats) ? cheats : [];
          cheatsList.sort((a, b) => a.timeMs - b.timeMs);
          this.cheatMarkers = cheatsList;
        }
      }).catch(err => {
        Message.error('获取用户详情失败');
        console.error(err);
      });
    },

    // 关闭备注弹窗
    handleCloseRemarkModal() {
      this.showRemarkModal = false;
      this.remarkForm.content = '';
      this.$nextTick(() => {
        if (this.$refs.remarkForm) {
          this.$refs.remarkForm.clearValidate();
        }
      });
    },

    // 提交备注
    handleSubmitRemark() {
      this.$refs.remarkForm.validate((valid) => {
        if (valid) {
          this.submitting = true;

          saveStudentInvigilateRemark(this.roomId, this.userId, {
            content: this.remarkForm.content.trim()
          }).then(res => {
            if (res.code === 200) {
              Message.success('备注提交成功');
              this.handleCloseRemarkModal();
              // 重新获取用户详情
              this.getUserDetail();
            } else {
              Message.error(res?.message || '备注提交失败');
            }
          }).catch(err => {
            Message.error('备注提交失败');
            console.error(err);
          }).finally(() => {
            this.submitting = false;
          });
        }
      });
    }
  },
};
</script>

<style scoped lang="less">
.teacher-invigilation-bg {
  background: #EDE4DA;
  min-height: 100vh;
  padding-top: 72px;
  box-sizing: border-box;
}

.teacher-invigilation-container {
  max-width: 1400px;
  margin: 24px auto;
  padding: 0 24px 40px;
}
.teacher-invigilation-main {
  background: #fff;
  padding: 36px 40px;
  border-radius: 12px;
  margin-top: 16px;
}
.page-title-warp {
  position: relative;
  text-align: center;
  width: 100%;
  font-weight: 600;
  margin-bottom: 20px;

  .back {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 16px;
    color: #4E5969;
    cursor: pointer;

    i {
      color: #4E5969;
      margin-right: 8px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: 600;
    color: #000000;

    i {
      width: 24px;
      height: 24px;
      background: url("@/common/images/ic_title_record.png") no-repeat center center;
      background-size: cover;
      margin-right: 6px;
    }
  }
}

.user-info-card {
  background: #F2F3F5;
  border-radius: 4px;
  padding: 0 24px;
  margin-bottom: 20px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  .info-left {
    display: flex;
    align-items: center;
  }

  .info-item {
    display: flex;
    align-items: center;
    margin-right: 30px;
    font-size: 14px;

    .label {
      color: #4E5969;
      font-weight: 500;
      margin-right: 4px;
    }

    .value {
      color: #1D2129;
      font-weight: 500;
    }
  }
  .result-tag {
    font-weight: 500;
    background: var(--color-text-1, #000000E5);
    height: 36px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    border-radius: 4px;
    background: #E8F7E8;
    &::before {
      content: '';
      width: 16px;
      height: 16px;
      margin-right: 4px;
      background: url("@/common/images/ic_correct2.png") no-repeat center center;
      background-size: contain;
    }
    &.warning {
      background: #FAEBEB;
      &::before {
        background-image: url("@/common/images/ic_warning.png");
      }
    }
  }
}
.remarks-btn-wrap {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;
  .remark-btn {
    width: 120px;
    height: 36px;
    font-size: 14px;
  }
}
.remarks-section {
  border: 1px solid #D8DCE5;
  border-radius: 4px;
  padding: 20px 24px;
  margin-bottom: 36px;
  .remark-item {
    color: #1D2129;
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    &_text {
      margin-right: 20px;
      &.bold {
        font-weight: 500;
      }
    }
    &:last-child {
      margin-bottom: 0;
    }
    &::before {
      content: '';
      display: block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background: #E60012;
      margin-right: 8px;
    }
  }
}

.remark-modal {
  /deep/ .base-modal_cnt {
    padding: 40px 40px 36px;
  }
  /deep/ .base-modal_title {
    width: 100%;
    color: var(--color-text-1, #000000E5);
    font-size: 24px;
    margin-top: 0;
    margin-bottom: 24px;
  }
}
.remark-modal-content {
  width: 500px;

  .modal-footer {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    gap: 12px;
    .footer-btn {
      width: 172px;
      font-size: 16px;
      &:last-child {
        &:hover {
          background: #d5000f;
        }
      }
    }
  }
}

// 弹窗标题样式
/deep/ .base-modal_title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #1D2129;

  .title-icon {
    width: 20px;
    height: 20px;
    background: url("@/common/images/student/ic_edit.png") no-repeat center center;
    background-size: contain;
    margin-right: 8px;
  }
}

// 表单样式
/deep/ .el-form-item__label {
  font-size: 14px;
  color: #1D2129;
  font-weight: 500;
}

// 回放区域样式
.playback-section {
  margin-top: 24px;

  .playback-tabs {
    display: flex;
    border-bottom: 1px solid #E4E7ED;
    margin-bottom: 20px;

    .tab-item {
      padding: 12px 24px;
      font-size: 16px;
      font-weight: 500;
      color: #606266;
      cursor: pointer;
      border-bottom: 2px solid transparent;
      transition: all 0.3s;

      &:hover {
        color: #E60012;
      }

      &.active {
        color: #E60012;
        border-bottom-color: #E60012;
      }
    }
  }
}
</style>
